var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".market-box{max-width:100%;background-color:#fff}.market-search-bar{width:50%;height:64px;border-radius:60px;border:1px solid #e2e2e2;background-color:#fff;position:relative;padding-left:50px}.market-search-bar input{width:calc(100% - 50px);height:64px;font-family:NanumBarunGothicUltraLightOTF;font-size:18px;color:#d9d9d9;background-color:transparent;border:none;line-height:3.56;outline:none}.market-search-bar:before{content:\"\";background-image:url(" + escape(require("../../images/search-icon@2x.png")) + ");background-size:25px 25px;display:inline-block;width:25px;height:25px;object-fit:contain;position:absolute;top:50%;left:20px;transform:translateY(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ea3dceae","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MarketManager/Market.vue
// module id = 169
// module chunks = 0